<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center login-outer-container"
  >
    <div class="col-12 col-md-7 col-lg-5 col-xl-4 p-0">
      <div class="d-flex justify-content-center">
        <div class="mt-3">
          <img
            src="/favicon/c3-logo.png"
            class="rounded"
            alt="Community Care Connection"
          />
        </div>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-4 my-5 p-0">
      <div class="card shadow-card p-5 login-box-container">
        <h1 class="display-4 text-center mb-3">Sign in</h1>
        <p class="text-muted text-center mb-5">Community Care Connection</p>
        <p class="text-center" v-if="!auth.iframeSrc">
          <router-link to="/register" class="btn-outline-primary btn mb-5 h2"
            >Don't Have an Account, Join Now!</router-link
          >
        </p>

        <div class="form-group">
          <label>Email Address</label>
          <input
            type="email"
            v-model="email"
            class="form-control"
            placeholder="name@address.com"
            tabindex="1"
            v-on:keyup.enter="doLogin"
          />
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col">
              <label>Password</label>
            </div>
            <div class="col-auto" v-if="!auth.iframeSrc">
              <router-link to="/forgot-password" class="form-text small"
                >Forgot Password?</router-link
              >
            </div>
          </div>
          <div class="input-group input-group-merge">
            <input
              :type="fieldType"
              v-model="password"
              class="form-control form-control-appended"
              tabindex="2"
              placeholder="Enter your password"
              v-on:keyup.enter="doLogin"
            />
            <div class="input-group-append">
              <span class="input-group-text">
                <i class="fe" :class="eyeClass" @click="togglePassword"></i>
              </span>
            </div>
          </div>
        </div>
        <div v-if="auth.error" class="alert alert-danger">
          {{ auth.error.message }}
        </div>
        <!-- Submit -->
        <button
          @click="doLogin()"
          :disabled="auth.authenticating"
          type="button"
          class="btn btn-lg btn-block btn-primary mb-3"
        >
          <span v-if="!auth.authenticating">Sign In</span>
          <span
            class="spinner-border spinner-border-sm"
            v-if="auth.authenticating"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
        <div class="text-center" v-if="!auth.iframeSrc">
          <small class="text-muted text-center">
            Don't have an account yet?
            <router-link to="/register">Sign up</router-link>.
          </small>
        </div>
      </div>
    </div>
    <secondStepVerification :user="user" />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import secondStepVerification from "./second-step-verification.vue";
import Auth from "@/auth.js";

export default {
  name: "Login",
  components: {
    secondStepVerification,
  },
  computed: {
    ...mapState(["auth"]),
    fieldType: function () {
      return this.showPassword ? "text" : "password";
    },
    eyeClass: function () {
      return this.showPassword ? "fe-eye-off" : "fe-eye";
    },
  },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      user: null,
    };
  },
  methods: {
    ...mapActions({
      getVendors: "vendors/getSignedInVendors",
    }),
    doLogin: function () {
      let vm = this;
      this.$store.commit("auth/SET_AUTHENTICATING", true);
      this.$store
        .dispatch("auth/login", {
          user: this.email,
          password: this.password,
        })
        .then((result) => {
          if (result) {
            vm.user = result;
            if (vm.auth.secondStepVerificationEnabled === true) {
              vm.$store.dispatch("showModal", "second-step-verification");
            } else {
              Auth.verify.set(true);
              if ((vm.user || {}).isVendor) {
                vm.getVendors({
                  accessToken: vm.auth.token,
                }).then(function (vendors) {
                  if (vendors && vendors.length) {
                    window.location.href = `/vendors/${vendors[0].id}?login=${vendors.length}`;
                  }
                });
              } else {
                window.location.href = "/";
              }
            }
          }
        });
    },
    togglePassword: function () {
      this.showPassword = this.showPassword ? false : true;
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 1024px) {
  .login-outer-container {
    margin-top: -84px;
  }
}
</style>
